// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.receipt-note .note-warning {\n  color: #ff003f;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n", ""]);
// Exports
module.exports = exports;
